// Muutoksen esteet v2 (#1364): ankkurit.v2 — the `ankkuritV2` namespace.
// v1's screen keeps its strings under `systemicV2`.

export const ankkuritV2Fi = {
  mine: 'Omat',
  all: 'Kaikki',
  allCount: 'Kaikki, {{count}} estettä',
  barrierCount: '{{count}} estettä',
  barrierOne: '1 este',
  noBarriersYet: 'Ei vielä esteitä',
  lensCount: '{{name}} · {{count}} estettä',
  lensCountOne: '{{name}} · 1 este',
  closePanel: 'Sulje lista',
  hideTitles: 'Piilota otsikot',
  showTitles: 'Näytä otsikot',
  orbs: 'Kooste',
  byLens: 'Linssi',
  byProblem: 'Ongelma',
  byYhteenveto: 'Yhteenveto',
  y: {
    pending: 'Yhteenveto valmistuu',
    pendingHint: 'Fasilitaattori avaa sen hetken päästä.',
    generating: 'Luetaan esteitä yhdessä…',
    generatingHint: 'Esteistä etsitään yhteiset teemat ja samat havainnot. Tämä kestää noin minuutin.',
    failed: 'Yhteenvetoa ei saatu muodostettua.',
    failedWhy: 'Syy: {{why}}',
    lock: 'Lukitse ja näytä',
    locked: 'Lukittu: osallistujat näkevät yhteenvedon',
    again: 'Päivitä yhteenveto',
    againConfirm: 'Tehdäänkö yhteenveto uudelleen nykyisistä esteistä? Edellinen tallentuu, ja yhteenveto on osallistujilta piilossa, kunnes lukitset sen uudelleen.',
    aiMark: 'Teemat ja konsensuksen ryhmitteli tekoäly osallistujien esteistä; sokeat pisteet on laskettu suoraan esteistä.',
    themes: 'Yhteiset teemat',
    themesNone: 'Esteistä ei noussut teemaa, joka toistuisi usean ongelman alla.',
    konsensus: 'Konsensus',
    konsensusNone: 'Kukaan ei kirjoittanut samaa estettä kuin toinen pari.',
    blindSpots: 'Sokeat pisteet',
    blindSpotsNone: 'Jokaista linssiä on käytetty ja jokaisella ongelmalla on esteitä.',
    unusedLenses: 'Linssit, joiden kautta ei kirjoitettu esteitä',
    emptyProblems: 'Ongelmat, joilla ei vielä ole esteitä',
    barriers: '{{count}} estettä',
    barriersOne: '1 este',
    problems: '{{count}} ongelman alla',
    problemsOne: '1 ongelman alla',
    pairs: '{{count}} paria',
    pairsOne: '1 pari',
  },
  noProblemsAll: 'Ongelmia ei ole vielä kirjoitettu.',
  add: 'Lisää este',
  noProblems: 'Sinulla ei ole vielä ongelmia. Kirjoita ensin ongelma Ongelmat-vaiheessa.',
  chooseLens: 'Valitse, minkä linssin läpi tarkastelet ongelmaa',
  // {{elative}}: lenses.json `elative`, the phrase before "näkökulmasta"
  questionElative: 'Mikä estää muutosta tässä ongelmassa {{elative}} näkökulmasta?',
  questionNamed: 'Mikä estää muutosta tässä ongelmassa linssin {{lens}} näkökulmasta?',
  placeholder: 'Kirjoita este tähän…',
  changeLens: 'Vaihda linssi',
  continue: 'Jatka',
  checking: 'Tarkistetaan…',
  saving: 'Tallennetaan…',
  originalLabel: 'Kirjoittamasi este',
  suggestionLabel: 'Ehdotus',
  actorQuestion: 'Kuka tai mikä pitää esteen yllä?',
  actorBlank: '___',
  other: 'Muu…',
  otherPlaceholder: 'Kirjoita oma vastauksesi…',
  useSuggestion: 'Käytä ehdotusta',
  saveOwn: 'Tallenna omana',
  close: 'Sulje',
  error: 'Jokin meni pieleen',
  noBarriers: 'Esteitä ei ole vielä kirjoitettu.',
  fromProblem: 'Ongelmasta',
  suggest: 'Anna Kuution ehdottaa esteitä',
  suggesting: 'Kuutio etsii esteitä lähteistä…',
  suggestFailed: 'Kuutio ei nyt löytänyt ehdotuksia. Yritä uudelleen tai kirjoita oma este.',
  suggestedHeading: 'Kuution ehdotukset – valitse lisättävät',
  select: 'Valitse',
  aiMark: 'Kuution ehdotus',
  groundingTitle: 'Tietopohjaisuus',
  groundingPending: 'Arvioidaan tietopohjaisuutta…',
  groundingFailed: 'Tietopohjaisuutta ei voitu arvioida',
  groundingMissing: 'Tätä estettä ei ole arvioitu.',
  groundingRagDown: 'Tutkimusaineistoa ei saatu haettua, joten luku voi olla todellista pienempi.',
  groundingNoSources: 'Työpajan omasta aineistosta ei löytynyt tukevia otteita.',
  groundingNoSourcesWeb: 'Työpajan aineistosta tai verkosta ei löytynyt tukevia lähteitä.',
  groundingWebDown: 'Verkkohaku ei onnistunut, joten luku voi olla todellista pienempi.',
  groundingPendingShort: 'arvioidaan…',
  outOfReach: 'Työpajan ulkopuolelta',
  outOfReachHint: 'Aihe, jota kukaan työpajassa ei ole vielä ottanut esiin.',
  showSources: 'Lähteet',
  hideSources: 'Piilota lähteet',
  fromResearch: 'tutkimuksesta',
  addSelected: 'Lisää valitut ({{count}})',
  writeOwn: 'Kirjoita oma',
  esteLabel: 'Este',
  remove: 'Poista este',
  removeMessage: 'Poistetaanko este? Sitä ei voi palauttaa.',
  removeConfirm: 'Poista',
  removeBlocked: 'Estettä ei voi poistaa, koska sen juurisyitä on jo käsitelty.',
};

export const ankkuritV2En = {
  mine: 'Mine',
  all: 'All',
  allCount: 'All, {{count}} obstacles',
  barrierCount: '{{count}} obstacles',
  barrierOne: '1 obstacle',
  noBarriersYet: 'No obstacles yet',
  lensCount: '{{name}} · {{count}} obstacles',
  lensCountOne: '{{name}} · 1 obstacle',
  closePanel: 'Close the list',
  hideTitles: 'Hide titles',
  showTitles: 'Show titles',
  orbs: 'Overview',
  byLens: 'Lens',
  byProblem: 'Problem',
  byYhteenveto: 'Summary',
  y: {
    pending: 'The summary is on its way',
    pendingHint: 'The facilitator will open it shortly.',
    generating: 'Reading the obstacles together…',
    generatingHint: 'Looking for the themes and the same observations in the obstacles. This takes about a minute.',
    failed: 'The summary could not be made.',
    failedWhy: 'Reason: {{why}}',
    lock: 'Lock and show',
    locked: 'Locked: the participants see the summary',
    again: 'Update the summary',
    againConfirm: 'Make the summary again from the current obstacles? The previous one is kept, and the participants do not see the summary until you lock it again.',
    aiMark: 'AI grouped the themes and the consensus from the participants\u2019 obstacles; the blind spots are counted straight from the obstacles.',
    themes: 'Shared themes',
    themesNone: 'No theme recurs under several problems.',
    konsensus: 'Consensus',
    konsensusNone: 'No pair wrote the same obstacle as another.',
    blindSpots: 'Blind spots',
    blindSpotsNone: 'Every lens was used and every problem has obstacles.',
    unusedLenses: 'Lenses no obstacle was written through',
    emptyProblems: 'Problems with no obstacles yet',
    barriers: '{{count}} obstacles',
    barriersOne: '1 obstacle',
    problems: 'under {{count}} problems',
    problemsOne: 'under 1 problem',
    pairs: '{{count}} pairs',
    pairsOne: '1 pair',
  },
  noProblemsAll: 'No problems have been written yet.',
  add: 'Add an obstacle',
  noProblems: 'You have no problems yet. Write a problem first in the Problems phase.',
  chooseLens: 'Choose the lens you look at the problem through',
  questionElative: 'What stands in the way of change in this problem from the {{lens}} perspective?',
  questionNamed: 'What stands in the way of change in this problem from the {{lens}} perspective?',
  placeholder: 'Write the obstacle here…',
  changeLens: 'Change the lens',
  continue: 'Continue',
  checking: 'Checking…',
  saving: 'Saving…',
  originalLabel: 'The obstacle you wrote',
  suggestionLabel: 'Suggestion',
  actorQuestion: 'Who or what keeps the obstacle in place?',
  actorBlank: '___',
  other: 'Other…',
  otherPlaceholder: 'Write your own answer…',
  useSuggestion: 'Use the suggestion',
  saveOwn: 'Save my own',
  close: 'Close',
  error: 'Something went wrong',
  noBarriers: 'No obstacles have been written yet.',
  fromProblem: 'From the problem',
  suggest: 'Let Kuutio suggest obstacles',
  suggesting: 'Kuutio is searching the sources for obstacles…',
  suggestFailed: 'Kuutio found no suggestions this time. Try again, or write your own.',
  suggestedHeading: 'Kuutio’s suggestions – choose the ones to add',
  select: 'Choose',
  aiMark: 'Suggested by Kuutio',
  groundingTitle: 'Research basis',
  groundingPending: 'Rating the research basis…',
  groundingFailed: 'The research basis could not be rated',
  groundingMissing: 'This obstacle has not been rated.',
  groundingRagDown: 'The research could not be searched, so the number may be lower than it should be.',
  groundingNoSources: 'No supporting excerpts were found in the workshop\'s own material.',
  groundingNoSourcesWeb: 'No supporting sources were found in the workshop\'s material or on the web.',
  groundingWebDown: 'The web search failed, so the number may be lower than it should be.',
  groundingPendingShort: 'rating…',
  outOfReach: 'Beyond the workshop',
  outOfReachHint: 'A topic nobody in the workshop has raised yet.',
  showSources: 'Sources',
  hideSources: 'Hide sources',
  fromResearch: 'from the research',
  addSelected: 'Add selected ({{count}})',
  writeOwn: 'Write my own',
  esteLabel: 'Obstacle',
  remove: 'Remove obstacle',
  removeMessage: 'Remove the obstacle? It cannot be restored.',
  removeConfirm: 'Remove',
  removeBlocked: 'The obstacle cannot be removed: the participants have already worked on its root causes.',
};

export const ankkuritV2Sv = {
  mine: 'Mina',
  all: 'Alla',
  allCount: 'Alla, {{count}} hinder',
  barrierCount: '{{count}} hinder',
  barrierOne: '1 hinder',
  noBarriersYet: 'Inga hinder ännu',
  lensCount: '{{name}} · {{count}} hinder',
  lensCountOne: '{{name}} · 1 hinder',
  closePanel: 'Stäng listan',
  hideTitles: 'Dölj rubriker',
  showTitles: 'Visa rubriker',
  orbs: 'Översikt',
  byLens: 'Lins',
  byProblem: 'Problem',
  byYhteenveto: 'Sammanfattning',
  y: {
    pending: 'Sammanfattningen är på väg',
    pendingHint: 'Facilitatorn öppnar den om en stund.',
    generating: 'Hindren läses tillsammans…',
    generatingHint: 'Gemensamma teman och samma iakttagelser söks i hindren. Det tar ungefär en minut.',
    failed: 'Sammanfattningen kunde inte göras.',
    failedWhy: 'Orsak: {{why}}',
    lock: 'Lås och visa',
    locked: 'Låst: deltagarna ser sammanfattningen',
    again: 'Uppdatera sammanfattningen',
    againConfirm: 'Göra sammanfattningen på nytt av de nuvarande hindren? Den förra sparas, och deltagarna ser inte sammanfattningen förrän du låser den igen.',
    aiMark: 'AI grupperade temana och konsensus ur deltagarnas hinder; de blinda fläckarna är räknade direkt ur hindren.',
    themes: 'Gemensamma teman',
    themesNone: 'Inget tema återkommer under flera problem.',
    konsensus: 'Konsensus',
    konsensusNone: 'Inget par skrev samma hinder som ett annat.',
    blindSpots: 'Blinda fläckar',
    blindSpotsNone: 'Varje lins användes och varje problem har hinder.',
    unusedLenses: 'Linser som inget hinder skrevs genom',
    emptyProblems: 'Problem som ännu saknar hinder',
    barriers: '{{count}} hinder',
    barriersOne: '1 hinder',
    problems: 'under {{count}} problem',
    problemsOne: 'under 1 problem',
    pairs: '{{count}} par',
    pairsOne: '1 par',
  },
  noProblemsAll: 'Inga problem har skrivits ännu.',
  add: 'Lägg till ett hinder',
  noProblems: 'Du har inga problem ännu. Skriv först ett problem i fasen Problem.',
  chooseLens: 'Välj vilken lins du betraktar problemet genom',
  questionElative: 'Vad hindrar förändring i det här problemet ur perspektivet {{lens}}?',
  questionNamed: 'Vad hindrar förändring i det här problemet ur perspektivet {{lens}}?',
  placeholder: 'Skriv hindret här…',
  changeLens: 'Byt lins',
  continue: 'Fortsätt',
  checking: 'Kontrollerar…',
  saving: 'Sparar…',
  originalLabel: 'Hindret du skrev',
  suggestionLabel: 'Förslag',
  actorQuestion: 'Vem eller vad håller hindret vid liv?',
  actorBlank: '___',
  other: 'Annat…',
  otherPlaceholder: 'Skriv ditt eget svar…',
  useSuggestion: 'Använd förslaget',
  saveOwn: 'Spara mitt eget',
  close: 'Stäng',
  error: 'Något gick fel',
  noBarriers: 'Inga hinder har skrivits ännu.',
  fromProblem: 'Från problemet',
  suggest: 'Låt Kuution föreslå hinder',
  suggesting: 'Kuution söker hinder i källorna…',
  suggestFailed: 'Kuution hittade inga förslag nu. Försök igen eller skriv ditt eget.',
  suggestedHeading: 'Kuutions förslag – välj vilka som läggs till',
  select: 'Välj',
  aiMark: 'Kuutions förslag',
  groundingTitle: 'Kunskapsunderlag',
  groundingPending: 'Kunskapsunderlaget bedöms…',
  groundingFailed: 'Kunskapsunderlaget kunde inte bedömas',
  groundingMissing: 'Det här hindret har inte bedömts.',
  groundingRagDown: 'Forskningen kunde inte sökas, så talet kan vara lägre än det borde.',
  groundingNoSources: 'Inga stödjande utdrag hittades i workshoppens eget material.',
  groundingNoSourcesWeb: 'Inga stödjande källor hittades i workshoppens material eller på webben.',
  groundingWebDown: 'Webbsökningen misslyckades, så talet kan vara lägre än det borde.',
  groundingPendingShort: 'bedöms…',
  outOfReach: 'Utanför workshoppen',
  outOfReachHint: 'Ett ämne som ingen i workshoppen har tagit upp ännu.',
  showSources: 'Källor',
  hideSources: 'Dölj källor',
  fromResearch: 'ur forskningen',
  addSelected: 'Lägg till valda ({{count}})',
  writeOwn: 'Skriv mitt eget',
  esteLabel: 'Hinder',
  remove: 'Ta bort hindret',
  removeMessage: 'Ta bort hindret? Det kan inte återställas.',
  removeConfirm: 'Ta bort',
  removeBlocked: 'Hindret kan inte tas bort: deltagarna har redan arbetat med dess grundorsaker.',
};
